import parse from "html-react-parser";
import { Card, Container } from "react-bootstrap";

import PageHeader from "../../components/PageHeader";
import { useAppSelector } from "../../redux/Store";
import { authDataSelector } from "../../redux/slice/AuthDataSlice";

const PrivacyPolicy = () => {
  const { globalSettingsData } = useAppSelector(authDataSelector);
  return (
    <>
      <Container className="w-800 mt-5 pb-5">
        <PageHeader title="Privacy Policy" />
        <Card>
          <Card.Body className="h3">
            {globalSettingsData?.PRIVACY_POLICY?.value &&
              parse(globalSettingsData.PRIVACY_POLICY.value)}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
